import { getCategoryHref } from '../../utils/common/category';
import { GIFT_IDEA_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'giftIdeaGeneratorType',
      analyticsName: 'gift_idea_type',
      textLabel: 'Generate gift ideas for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: GIFT_IDEA_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Gift',
        value: getCategoryHref(GIFT_IDEA_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'giftIdeaGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'gift_ideas_generator',
      placeholder: 'Try "baby girl shower" or "10-year work anniversary"',
      textLabel: 'Describe the occasion and receiver',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: GIFT_IDEA_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
